<template>
    <div class="modal modal-open" id="modal-contacts-edit">
        <div class="modal-overflow">
            <div class="modal-window">
                <button class="btn btn-modal-close" @click="handleClose">
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6">
                            <div
                                class="form-field form-field--text"
                                style="padding-right: 24px"
                            >
                                <label for="firstname"
                                    >First name
                                    <span style="color: red">*</span></label
                                >
                                <input
                                    type="text"
                                    v-model="form_data.firstname"
                                    id="firstname"
                                />
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div
                                class="form-field form-field--text"
                                style="padding-right: 24px"
                            >
                                <label for="lastname"
                                    >Last name
                                    <span style="color: red">*</span></label
                                >
                                <input
                                    type="text"
                                    v-model="form_data.lastname"
                                    id="lastname"
                                />
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div
                                class="form-field form-field--text"
                                style="padding-right: 24px"
                            >
                                <label for="email"
                                    >E-mail
                                    <span style="color: red">*</span></label
                                >
                                <input
                                    type="text"
                                    v-model="form_data.email"
                                    id="email"
                                />
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div
                                class="form-field form-field--text"
                                style="padding-right: 24px"
                            >
                                <label for="title">Title</label>
                                <input
                                    type="text"
                                    v-model="form_data.title"
                                    id="title"
                                />
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div class="form-field form-field--tree">
                                <label for="firstname">System role</label>
                                <treeselect
                                    v-model="form_data.system_role"
                                    id="system_role"
                                    name="system_role"
                                    :multiple="false"
                                    :clearOnSelect="true"
                                    :options="roles"
                                />
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 group-row">
                            <div class="group-row__label">Business role</div>
                            <div class="row">
                                <div class="col-xl-6 col-lg-6">
                                    <div
                                        class="form-field checkbox-wrap checkbox-wrap--main-billing-contact"
                                        style="margin-bottom: 0"
                                    >
                                        <label>&nbsp;</label>
                                        <input
                                            type="checkbox"
                                            v-model="form_data.billing_contact"
                                            id="billing-contact"
                                            class="billing-contact"
                                            name="billing_contact"
                                        />
                                        <label for="billing-contact">
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                        <span style="font-size: 12px"
                                            >Billing contact</span
                                        >
                                    </div>
                                </div>

                                <div class="col-xl-6 col-lg-6">
                                    <div
                                        class="form-field checkbox-wrap checkbox-wrap--send-emails"
                                        style="margin-bottom: 0"
                                    >
                                        <label>&nbsp;</label>
                                        <input
                                            type="checkbox"
                                            v-model="form_data.sales_person"
                                            id="sales-person"
                                            class="send-emails"
                                            name="sales-person"
                                        />
                                        <label for="sales-person">
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                        <span style="font-size: 12px"
                                            >Sales person</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-8">
                            <div class="row">
                                <div class="col-xl-6 col-lg-6">
                                    <div
                                        class="form-field checkbox-wrap checkbox-wrap--main-billing-contact"
                                    >
                                        <label>&nbsp;</label>
                                        <input
                                            type="checkbox"
                                            v-model="form_data.create_user"
                                            id="form_data"
                                            class="form_data"
                                            name="form_data"
                                        />
                                        <label for="form_data">
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                        Create user
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6">
                                    <div
                                        class="form-field checkbox-wrap checkbox-wrap--send-emails"
                                    >
                                        <label>&nbsp;</label>
                                        <input
                                            type="checkbox"
                                            v-model="form_data.sendEmails"
                                            id="send-emails"
                                            class="send-emails"
                                            name="send-emails"
                                        />
                                        <label for="send-emails">
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                        Send e-mails
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 group-row">
                            <div class="row">
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--text"
                                        style="padding-right: 24px"
                                    >
                                        <label for="address_line_1"
                                            >Address line 1</label
                                        >
                                        <input
                                            type="text"
                                            v-model="
                                                form_data.address.address_line_1
                                            "
                                            id="address_line_1"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--text"
                                        style="padding-right: 24px"
                                    >
                                        <label for="address_line_2"
                                            >Address line 2</label
                                        >
                                        <input
                                            type="text"
                                            v-model="
                                                form_data.address.address_line_2
                                            "
                                            id="address_line_2"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--text"
                                        style="padding-right: 24px"
                                    >
                                        <label for="town">Town</label>
                                        <input
                                            type="text"
                                            v-model="form_data.address.town"
                                            id="town"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--tree"
                                        style="padding-right: 24px"
                                    >
                                        <label for="state">State</label>
                                        <treeselect
                                            v-model="form_data.address.state"
                                            id="state"
                                            name="state"
                                            :multiple="false"
                                            :options="roles"
                                            :clearOnSelect="true"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--tree"
                                        style="padding-right: 24px"
                                    >
                                        <label for="country">Country</label>
                                        <treeselect
                                            v-model="form_data.address.country"
                                            id="country"
                                            name="country"
                                            :multiple="false"
                                            :options="roles"
                                            :clearOnSelect="true"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div
                                        class="form-field form-field--text"
                                        style="padding-right: 24px"
                                    >
                                        <label for="zip">Zip</label>
                                        <input
                                            type="text"
                                            v-model="form_data.address.zip"
                                            id="zip"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row btn-wrap btn-wrap--center">
                        <button
                            @click.prevent="toggleContactModal"
                            class="btn btn--gray"
                        >
                            Add contact
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "addContactModal",
    props: ["closeModal"],
    components: {
        Treeselect,
    },
    data() {
        return {
            form_data: {
                firstname: "",
                lastname: "",
                email: "",
                title: "",
                system_role: null,
                billing_contact: false,
                sales_person: false,
                create_user: false,
                sendEmails: false,
                address: {
                    address_line_1: "",
                    address_line_2: "",
                    town: "",
                    state: null,
                    country: null,
                    zip: "",
                },
            },
            roles: [
                {
                    id: 1,
                    value: "Test 1",
                },
                {
                    id: 2,
                    value: "Test 2",
                },
                {
                    id: 3,
                    value: "Test 3",
                },
            ],
        };
    },
    methods: {
        handleClose(e) {
            this.closeModal(e);
        },
    },
};
</script>
